import ActionButton from '@atoms/button';
import {
  SettingHeader,
  SettingsContainer,
  SettingsContent
} from '@components/ui/settings';
import useProcess from '@hooks/useProcess';
import useStores from '@hooks/useStore';
import { CircularProgress } from '@mui/joy';
import { observer } from 'mobx-react';
import { useNavigate } from 'react-router-dom';
import { LoaderBox } from '@/components/ui/loader';

import { NotificationItem } from './notificationItem';

const SettingNotifications = () => {
  const navigate = useNavigate();
  const { notificationTemplateStore } = useStores();
  const process = useProcess();
  const notificationTemplates = notificationTemplateStore.toArray();

  if (!process || process.isSmallProcess) {
    return (
      <LoaderBox>
        <CircularProgress />
      </LoaderBox>
    );
  }

  return (
    <SettingsContainer>
      <SettingHeader
        description="Create and customize Trace email template"
        title="Notifications"
      />
      <SettingsContent>
        <div className="title-body">
          <h3>Template(s)</h3>
          <ActionButton
            onClick={() => navigate('new')}
            value="Add a template"
          />
        </div>
        <div className="mt-5 flex flex-col gap-4">
          {notificationTemplates?.map(notif => (
            <NotificationItem
              id={notif.id}
              key={notif.id}
              title={notif.title}
              updateAt={notif.updatedAt}
            />
          ))}
        </div>
      </SettingsContent>
    </SettingsContainer>
  );
};

export default observer(SettingNotifications);
